import { Box, FormControl, FormControlLabel, Radio, RadioGroup as MuiRadioGroup, Typography } from '@mui/material';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RadioGroup } from 'components/common';
import { PartnershipCreationMode, PartnershipIdentityToShow } from '../types';

const PartnershipSetupSettings: FC = () => {
  const { control } = useFormContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, flexWrap: 'nowrap', gap: 2 }}>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: .5 }}>
        <Typography variant="subtitle2">Identities in display in header</Typography>
        <RadioGroup
          name="partnershipIdentityToShow"
          options={[
            { value: PartnershipIdentityToShow.DYNAMIC, label: 'Dynamic identity' },
            { value: PartnershipIdentityToShow.BOTH, label: 'Both identities' },
            { value: PartnershipIdentityToShow.FIRST_ONLY, label: 'First identity only' },
          ]}
        />
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: .5 }}>
        <Typography variant="subtitle2">First identity</Typography>
        <Controller
          control={control}
          name="partnershipIsPartnerIdentityFirst"
          render={({ field }) => (
            <FormControl>
              <MuiRadioGroup
                value={String(Boolean(field.value))}
                onChange={(_, value) => {
                  field.onChange(value === 'true');
                }}
              >
                <FormControlLabel value={'false'} control={<Radio />} label="Facebook page" />
                <FormControlLabel value={'true'} control={<Radio />} label="Partnerships" />
              </MuiRadioGroup>
            </FormControl>
          )}
        />
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="subtitle2">Setup settings</Typography>
        <RadioGroup
          name="partnershipCreationMode"
          options={[
            {
              value: PartnershipCreationMode.BOTH,
              label: 'Create 2 ads in adset: App identity + App+PA identity',
            },
            {
              value: PartnershipCreationMode.PARTNERSHIP_ONLY,
              label: 'Create 1 ad in adset: App&PA identity',
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default PartnershipSetupSettings;
